import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthAppService } from 'avn/services/auth-app/auth-app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessGuard {
  // List of route paths accessible by practitioner users
  practitionersAccess = [
    'bookings',
    'client-list',
    'forms',
    'home',
    'integration',
    'partnership',
    'payments',
    'practitioner',
    'services',
    'services/workcover',
    'services/corporate'
  ];

  constructor(
    private auth: AuthAppService,
    private router: Router
  ) {}

  /**
   * Determines whether the user is allowed to activate the route.
   * Practitioners are restricted to certain paths.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getSavedUser()?.email && this.auth.getSavedUser()?.businesses?.length > 0) {
      const currentPath = state.url; // Get the current path
      const match = currentPath.match(/(business\/[^/]+)/);
      const basePath = match ? match[1] : '';
      const hasAccess = this.practitionersAccess.some((accessPath: string) => currentPath.includes(accessPath));
      if (this.isOnlyPractitioner() && hasAccess) {
        return true;
      } else if (this.isOnlyPractitioner() && !hasAccess) {
        this.router.navigate([basePath]);
        return false;
      }
      return true;
    } else {
      this.router.navigate(['']);
      return false;
    }
  }

  /**
   * Checks if the current user view type is 'practitioner'.
   */
  isOnlyPractitioner() {
    return this.auth.getViewType() === 'practitioner';
  }
}
